import React from 'react'
import { css } from '@emotion/core'
import Lottie from 'react-lottie'
import { useTranslation } from 'react-i18next'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

const animationData = require('@/static/images/json/loading.json')

export const ProgressDialog: React.FC<{}> = () => {
  const { t } = useTranslation()

  return (
    <>
      <div css={backgroundStyle}></div>
      <div css={dialogStyle}>
        <div className="content-block">
          <Lottie height="70px" width="70px" style={{ margin: 0 }} options={{ animationData, autoplay: true, loop: true }} />
          <div className="-text">{t('Inquiring at the center')}</div>
        </div>
      </div>
    </>
  )
}

const backgroundStyle = css({
  background: 'rgba(0, 0, 0, 0.5)',
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
})
const dialogStyle = css(
  {
    position: 'fixed',
    zIndex: 1001,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 480,
    minHeight: 117,
    background: '#FFFFFF',
    borderRadius: 10,
    '.content-block': {
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      width: '100%',
      height: '100%',
      padding: '24px 32px',
    },
    '.-text': {
      fontSize: 28,
      lineHeight: '41px',
      fontWeight: 'bold',
      letterSpacing: 1.4,
      color: '#272727',
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { minWidth: 501, '.-text': { fontSize: 32, lineHeight: '44px', letterSpacing: 1.6 } },
  }),
)
